const SourceType = {
    PreChat: 1,
    VideoGreet: 2
};
export default SourceType;
